import { Link } from "react-router-dom";
import { seoArticles } from "@/mocks/seoArticles";

export default function SeoArticlesSection() {
  return (
    <section className="relative bg-background-50 py-16 md:py-24 px-6 md:px-10">
      <div className="max-w-6xl mx-auto">
        {/* Section Header */}
        <div className="text-center mb-12 md:mb-16">
          <span className="inline-block px-3 py-1 text-xs font-medium text-accent-600 bg-accent-50 rounded-full mb-4">
            Blog SEO
          </span>
          <h2 className="font-heading text-3xl md:text-4xl text-foreground-900 font-medium mb-4">
            Guias e Artigos Hoobuy
          </h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-xl mx-auto">
            Conteúdo original em português para ajudar nas suas compras com segurança
          </p>
        </div>

        {/* Articles Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
          {seoArticles.map((article) => (
            <Link
              key={article.id}
              to={`/artigo/${article.slug}`}
              className="group bg-background-100 rounded-2xl overflow-hidden hover:bg-background-100/80 transition-all cursor-pointer"
            >
              {/* Image */}
              <div className="aspect-[4/3] overflow-hidden">
                <img
                  src={article.image}
                  alt={article.title}
                  title={article.title}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                  loading="lazy"
                />
              </div>

              {/* Content */}
              <div className="p-5 md:p-6">
                {/* Category Tag */}
                <span className="inline-block px-2.5 py-1 text-xs font-medium text-accent-700 bg-accent-100 rounded-full mb-3">
                  {article.category}
                </span>

                {/* Title */}
                <h3 className="font-heading text-base md:text-lg text-foreground-900 font-medium mb-2.5 leading-snug group-hover:text-primary-600 transition-colors line-clamp-2">
                  {article.title}
                </h3>

                {/* Excerpt */}
                <p className="text-foreground-600 text-xs md:text-sm leading-relaxed line-clamp-2 mb-4">
                  {article.excerpt}
                </p>

                {/* Read More */}
                <span className="inline-flex items-center gap-1.5 text-xs font-semibold text-primary-600 group-hover:text-primary-700 transition-colors">
                  Ler artigo
                  <i className="ri-arrow-right-line text-xs"></i>
                </span>
              </div>
            </Link>
          ))}
        </div>

        {/* View All Link */}
        <div className="text-center mt-10 md:mt-12">
          <Link
            to="/artigo/guia-completo-hoobuy-spreadsheet"
            className="inline-flex items-center gap-2 text-sm font-medium text-foreground-600 hover:text-primary-600 transition-colors cursor-pointer"
          >
            Ver todos os artigos
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}